import api from 'store/actions/api';
import { getTrackingId } from 'components/user/selectors';

export const dislikeAd = (adId, isDislike = true) =>
  function* ({ getState }) {
    const trackingId = getTrackingId(getState());

    if (trackingId) {
      if (isDislike) {
        return yield api.addAdToDislikes(trackingId, adId);
      }

      return yield api.removeAdFromDislikes(trackingId, adId);
    }
  };
